import { message as antdMessage } from "antd";
import { hasShownGlobalError } from "./servicesUtils";
import { setFeedbackState } from "@/store/feedback";

// 创建一个包装的 message 对象，自动检查是否已经显示了全局错误
export const message = {
  success: (content: string, duration?: number) => {
    antdMessage.success(content, duration);
  },

  error: (content: string, duration?: number) => {
    // 检查是否已经通过全局错误处理显示了错误提示
    if (!hasShownGlobalError()) {
      antdMessage.error(content, duration);
    } else {
      // 如果已经显示了全局错误，重置标记以便下次使用
      setFeedbackState({
        hasShownGlobalError: false,
      });
    }
  },

  warning: (content: string, duration?: number) => {
    antdMessage.warning(content, duration);
  },

  info: (content: string, duration?: number) => {
    antdMessage.info(content, duration);
  },

  loading: (content: string, duration?: number) => {
    antdMessage.loading(content, duration);
  },

  // 强制显示错误，不受全局错误处理影响
  forceError: (content: string, duration?: number) => {
    antdMessage.error(content, duration);
  },

  // 强制显示警告，不受全局错误处理影响
  forceWarning: (content: string, duration?: number) => {
    antdMessage.warning(content, duration);
  },

  // 强制显示信息，不受全局错误处理影响
  forceInfo: (content: string, duration?: number) => {
    antdMessage.info(content, duration);
  },

  // 强制显示成功，不受全局错误处理影响
  forceSuccess: (content: string, duration?: number) => {
    antdMessage.success(content, duration);
  },
};

export default message;
